import { render, staticRenderFns } from "./TabOrder.vue?vue&type=template&id=0aac7112"
import script from "./TabOrder.ts?vue&type=script&lang=ts&external"
export * from "./TabOrder.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports